import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import MasterCMS from './ContentMangementSystem/MasterCMS';
import AboutUs from './ContentMangementSystem/pages/policy/AboutUs';
import PrivacyPolicy from './ContentMangementSystem/pages/policy/PrivacyPolicy';
import TermsOfUse from './ContentMangementSystem/pages/policy/TermsOfUse';

const App: React.FC = () => {
  return (
      <Router>
          <Routes>
            <Route path="/" element={<MasterCMS />} />
            <Route path="/about-us" element={<AboutUs />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/terms-of-use" element={<TermsOfUse />} />
          </Routes>
      </Router>
  );
}

export default App;
